
import { Action } from '@ngrx/store';
import { YourProductApplication } from '../../model/ngrx/your-product-application.model';
import * as YourProductApplicationActions from './../actions/your-product-application.actions';

export type Actions = YourProductApplicationActions.Actions;

export function YourProductApplicationReducer(state: YourProductApplication[] = [], action: YourProductApplicationActions.Actions) {
    switch (action.type) {
        case YourProductApplicationActions.ADD_YOUR_PRODUCT_APPLICATION:
            return [...state, action.payload];

        // Add this case:
        case YourProductApplicationActions.REMOVE_YOUR_PPRODUCT_APPLICATION:
            state = [];
            return state;

        default:
            return state;
    }
}
